<template>
  <AppTooltip :disabled="!selectionTooLarge">
    <template #activator="{ props }">
      <!-- We use a wrapper div to retain the disable styling _and_ the tooltip hover event -->
      <div v-bind="props">
        <app-button :disabled="selectionTooLarge" @click="handleClick" type="ghost" variant="neutral">
          <template #left-icon>
            <app-icon-poly-office />
          </template>
          {{ $t('common.polyOffice.PolyOfficeMultiSelectBarButtonExport.exportFiles') }}
        </app-button>
      </div>
    </template>
    <span 
      v-t="{
        path: 'common.polyOfficeErrors.ERR_FILE_TOO_LARGE',
        plural: selectionCount,
      }"
    />
  </AppTooltip>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

import { POLYOFFICE_MAX_EXPORT_SIZE } from './constants.js'

export default {
  name: 'PolyOfficeMultiSelectBarButtonExport',
  components: {
    AppTooltip,
  },
  props: {
    selectionSize: {
      type: Number,
      required: true,
    },
    selectionCount: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    selectionTooLarge () {
      return POLYOFFICE_MAX_EXPORT_SIZE <= this.selectionSize
    },
  },
  methods: {
    handleClick () {
      this.$emit('polyOfficeOpenDialog')
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-btn:hover) {
  svg path {
    fill: #FFF;
  }
}
</style>
